import api from './api';

/**
 * Blog Service - Handles all blog-related API calls
 */
const blogService = {
  /**
   * Get all blog posts with optional parameters
   * @param {Object} params - Query parameters (limit, sort, published, etc.)
   * @returns {Promise} Resolves to a list of blog posts
   */
  getAll: async (params) => {
    try {
      const response = await api.get('api/blog', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching blog posts:', error);
      throw error;
    }
  },

  /**
   * Get a specific blog post by ID
   * @param {string} id - Blog post ID
   * @returns {Promise} Resolves to blog post details
   */
  get: async (id) => {
    try {
      const response = await api.get(`api/blog/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching blog post ${id}:`, error);
      throw error;
    }
  },
};

export default blogService;